import fetch from 'isomorphic-unfetch'

function login({ idToken, csrfToken }) {
  return fetch('/api/login', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'CSRF-Token': csrfToken },
    credentials: 'same-origin',
    body: JSON.stringify({ idToken }),
  })
}

function logout() {
  return fetch('/api/logout', {
    method: 'POST',
    credentials: 'same-origin',
  })
}

function getCustomToken() {
  return fetch('/api/customToken', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'same-origin',
  })
    .then(res => res.json())
    .then(json => json?.customToken)
}

export { fetch, login, logout, getCustomToken }
